export default "<p>combo-box works!</p>\r\n"